export const toAnchorId = (subject: string): string => `list-item-${subject}`;
